import type { PerformancePoint } from "../../api";

/** Prepare one card's visible month without changing sampled financial values. */
export default function cardHistory(history: PerformancePoint[] | undefined, since: number, now: number): PerformancePoint[] {
  if (!history?.length) return [];
  const first = history[0];
  const last = history[history.length - 1];
  // A windowed response includes the genuine preceding snapshot when one
  // exists. Its zero anchor is outside the window and is discarded below.
  // Only a bot whose actual history starts inside the month retains this zero.
  return [
    { ...first, timestamp: first.timestamp - 1, absoluteProfit: 0 },
    ...history,
    { ...last, timestamp: now },
  ].filter(point => point.timestamp >= since);
}
